module.exports = __webpack_public_path__ + "static/media/icon-warning-grey2.e65b761e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-warning-grey2.svg
// module id = 1496
// module chunks = 0